import { render, staticRenderFns } from "./info.vue?vue&type=template&id=ec3ac11c&scoped=true&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&id=ec3ac11c&prod&lang=less&scoped=true&"
import style1 from "./info.vue?vue&type=style&index=1&id=ec3ac11c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3ac11c",
  null
  
)

export default component.exports